
export const errorRouter = [
  // {
  //   path: '/404',
  //   component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
  //   meta: {
  //     hidden: true,
  //     title: '404',
  //     activeMenu: '/404'
  //   }
  // },
  // {
  //   path: '*',
  //   redirect: '/404',
  //   meta: { hidden: true, title: '404' }
  // }
]
